import AuthController from '../domain/controller.js'
import { EVENTS } from '../utils/constants.js'
import Commons from '@/shared/utils/commons.js'

async function makeLogout(context, payload) {
  console.log('🚀 ~ makeLogout ~ payload:', payload)
  const { events, localRepo, sendBugAlert } = context

  try {
    const user = await AuthController.deleteUserData(localRepo)
    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: `You are logged out`,
      body: `See you soon ${user?.firstName || ''}!`,
    })
  } catch (error) {
    let title = 'Logout error'
    let body =
      'We are unable to log you out. Please try again later. Our team has already been notified of the issue.'
    sendBugAlert(error)
    console.log('🚀 ~ makeLogout ~ error:', error)
    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title,
      body,
      type: 'error',
    })
    return
  }

  // Nettoyer Preferences natif avant de vider le localStorage
  try {
    await Commons.clearUserDataFromPreferences()
  } catch (e) {
    console.warn('Failed to clear Preferences', e)
  }

  // Vider tout le localStorage pour ne laisser aucune donnée de session résiduelle
  // (userData, riderId, tokens, etc.)
  localStorage.clear()

  // Forcer un rechargement complet de la page pour réinitialiser l'état de l'app
  window.location.reload()
}

export default makeLogout
